<template>
  <div>
    <div class="frameAroundLicence">
      <h5 v-if="popinSnomedBrowserLicence" class="modal-title w-100">{{ licenceTitle }}</h5>
      <h5 v-else class="modal-title w-100">{{ licenceTitle }}</h5>
      <!-- v-bind pour différencier les cas où la licence navigateur s'affiche dans une popin ou dans la pge -->
      <div
        v-bind:class="{ contentLicence: popinSnomedBrowserLicence, contentLicenceInPage: !popinSnomedBrowserLicence }"
        class="modal-body wysiwyg" style="overflow-y: scroll;" v-html="licenceText">
      </div>
      <p v-if="errorMessage" class="redTheme">L'acceptation de la licence navigateur SNOMED CT est obligatoire.</p>
      <div class="modal-footer">
        <div class="w-100 mb-2 custom-control custom-checkbox">
          <input type="checkbox" name="SnomedBrowserCheckbox" id="SnomedBrowserCheckbox" class="custom-control-input"
            v-model="agreement" style="cursor:pointer;">
          <label class="custom-control-label" :class="{ redTheme: hasError }" for="SnomedBrowserCheckbox"> J'ai lu et
            j'accepte les termes de la
            licence.</label>
        </div>
      </div>
      <!-- Cas btn pour la popin -->
      <div v-if="popinSnomedBrowserLicence" class="w-100">
        <button type="button" class="btn btn--primary btn--plain" @click="stockInLocalStorageIfCheckboxOk()">
          Valider
        </button>
        <a class="btn btn--primary btn--ghost homepage" v-bind:href="$searchResultManager.wordPressBaseUrl">
          Retourner à la page d'accueil
        </a>
      </div>
      <!-- Cas btn dans la page -->
      <div v-if="!popinSnomedBrowserLicence" class="btnsInComponent">
        <div class="w-100">
          <button type="button" class="btn btn--primary btn--plain btnComponentLeft mr-10"
            @click="stockInLocalStorageIfCheckboxOk()">
            Valider
          </button>
          <a class="btn btn--primary btn--ghost btnComponentRight" v-bind:href="$searchResultManager.wordPressBaseUrl">
            Retourner à la page d'accueil
          </a><br>
        </div>
      </div>
      <div>
        <!-- Lien de redirection vers le formulaire Snomed, present dans la popin et la page-->
        <a v-bind:href="$searchResultManager.wordPressBaseUrl + '/licences-snomed/'"
          class="btn--icon-before link-snomed-registration">
          <svg class="svg-icon svg-angle-right" aria-hidden="true" focusable="false">
            <use xlink:href="/wp-content/themes/ans/design-system/svg-icons/icon-sprite.svg#angle-right">
            </use>
          </svg>Se rendre sur l'espace affilié NRC SNOMED CT pour accepter les licences d'affiliation et éviter ce
          message.
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import ConceptsStore from "../../concepts-store";
import axios from 'axios';

export default {
  name: "SnomedBrowserLicenceComponent",
  props: {
    show: Boolean,
    popinSnomedBrowserLicence: Boolean
  },

  data() {
    return {
      store: ConceptsStore.state,
      errorMessage: false,
      agreement: false,
      hasError: false,
      licenceText: "",
      licenceTitle: ""
    }
  },
  async beforeCreate() {
    let baseUrl = this.$searchResultManager.wordPressBaseUrl;
    await axios.get(
      baseUrl + '/wp-json/ans/terminologies/browserSnomedlicence'
    ).then((response) => {

      this.licenceText = response.data.content;
      this.licenceTitle = response.data.title;
    });
  },


  methods: {
    stockInLocalStorageIfCheckboxOk: function () {
      if (this.agreement == false) {
        //afficher le message d'erreur
        this.errorMessage = true;
        this.hasError = true;
      }
      if (this.agreement == true) {
        // licence Browser acceptée - stocker user dans localStorage
        let currentDate = new Date();
        let timestamp = currentDate.getTime();
        let timestampToString = timestamp.toString();
        // Enregistrement de la licence navigateur dans le localStorage à la date du jour
        localStorage.setItem('snomedBrowserLicence', timestampToString);
        if (this.popinSnomedBrowserLicence) {
          // rechargement du deuxième parent (page Catalogue des concepts)
          this.$emit('refreshPage')
        } else {
          //Recharger la page avec les nouveaux paramètres (SnomedBrowserLicence OK)
          this.$parent.forceRerender();
        }
      }
    }
  }
}
</script>
<style scoped>
.redTheme {
  color: #D20024 !important;
  /* couleur erreur dans la charte graphique */
  /* Imporant to override the default behaviour */
}

.link-snomed-registration {
  margin-top: 2%;
}

@media(max-height:600px) {
  .homepage {
    display: none;
    /* Enlever le dernier bouton de grosse taille pour les très petits écrans */
  }
}

.notAPopinTitle {
  text-align: center;
  margin: 2em 2em 2em 2em;
  font-size: 2.4rem;
  font-weight: 600;
}

.twoBtnClass {
  color: #D20024;
}

.contentLicence {
  height: 300px;
  min-height: 100px;
}

.contentLicenceInPage {
  height: 400px;
  min-height: 100px;
}

.btnsInComponent {
  margin-top: 3% !important;
  margin-bottom: 3% !important;
  margin: auto;
  width: 60%;
}

.btnComponentRight {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 2.5rem !important;
  border-bottom-right-radius: 2.5rem !important;
  border-top-right-radius: 2.5rem !important;
}

.btnComponentLeft {
  border-top-left-radius: 2.5rem !important;
  border-bottom-left-radius: 2.5rem !important;
  border-bottom-right-radius: 2.5rem !important;
  border-top-right-radius: 0 !important;
}

@media (max-width: 768px) {
  .btnsInComponent {
    width: 100% !important;
  }

  .btnsInComponent .w-100 {
    display: flex;
    flex-direction: column;
  }

  .btnsInComponent button,
  .btnsInComponent a {
    width: 100% !important;
    margin: 0.5rem 0 !important;
    border-radius: 2.5rem !important;
  }
}

.modal-footer {
  justify-content: flex-start;
}

.frameAroundLicence {
  background-color: white;
  border-radius: 2.4rem;
  padding: 5%;
}
</style>